import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-upload-text"
}
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 添加应用分类 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_v_nodes = _resolveComponent("v-nodes")
  const _component_a_divider = _resolveComponent("a-divider")
  const _component_icon = _resolveComponent("icon")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_radio = _resolveComponent("a-radio")
  const _component_a_radio_group = _resolveComponent("a-radio-group")
  const _component_a_form = _resolveComponent("a-form")
  const _component_add_type = _resolveComponent("add-type")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "add-app-modal",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_ctx.visible = $event)),
    title: _ctx.title,
    width: "720px",
    afterClose: _ctx.afterClose,
    onCancel: _ctx.afterClose,
    onOk: _ctx.handleOk,
    maskClosable: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "label-col": { span: 4 },
        "wrapper-col": { span: 18 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "应用名称",
            name: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.form.name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                placeholder: "请输入应用名称"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "应用Code",
            name: "code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.form.code,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.code = $event)),
                placeholder: "请输入应用名称"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "应用LOGO",
            name: "icon"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_upload, {
                name: "avatar",
                style: {"width":"102px"},
                "list-type": "picture-card",
                class: "avatar-uploader icon-upload",
                "show-upload-list": false,
                customRequest: _ctx.customUploadRequest
              }, {
                default: _withCtx(() => [
                  (!_ctx.form.icon)
                    ? (_openBlock(), _createBlock("div", _hoisted_1, "上传"))
                    : (_openBlock(), _createBlock("img", {
                        key: 1,
                        style: {"width":"100%"},
                        src: _ctx.form.icon
                      }, null, 8, ["src"]))
                ]),
                _: 1
              }, 8, ["customRequest"]),
              _createVNode(_component_a_input, {
                value: _ctx.form.icon,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.icon = $event)),
                style: {"display":"none"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "应用描述",
            name: "desc"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                value: _ctx.form.desc,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.desc = $event)),
                placeholder: "请输入描述",
                "auto-size": { minRows: 4, maxRows: 4 }
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "应用分类",
            name: "typeId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                style: {"width":"100%"},
                value: _ctx.form.typeId,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.typeId = $event)),
                maxlength: 20,
                placeholder: "请选择"
              }, {
                dropdownRender: _withCtx(({ menuNode: menu }) => [
                  _createVNode(_component_v_nodes, { vnodes: menu }, null, 8, ["vnodes"]),
                  _createVNode(_component_a_divider, { style: {"margin":"4px 0"} }),
                  _createVNode("div", {
                    style: {"padding":"4px 8px","cursor":"pointer","display":"flex","justify-content":"center","align-items":"center","color":"#3372ff"},
                    onMousedown: _cache[5] || (_cache[5] = (e) => e.preventDefault()),
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
                  }, [
                    _createVNode("span", _hoisted_2, [
                      _createVNode(_component_icon, {
                        name: "add-upload",
                        scale: 1.5,
                        style: {"margin-right":"4px"}
                      }, null, 8, ["scale"]),
                      _hoisted_3
                    ])
                  ], 32)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "开通类型",
            name: "mode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.form.mode,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.mode = $event)),
                placeholder: "请选择开通类型",
                allowClear: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modeOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.value,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "应用功能包",
            name: "pkgId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.form.pkgId,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.pkgId = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.packageList, (item) => {
                    return (_openBlock(), _createBlock(_component_a_radio, {
                      key: item.value,
                      value: item.value,
                      label: item.label,
                      disabled: !item.enable
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label", "disabled"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      (_ctx.typeVisible)
        ? (_openBlock(), _createBlock(_component_add_type, {
            key: 0,
            onSuccess: _ctx.handleSuccess,
            onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.typeVisible = false))
          }, null, 8, ["onSuccess"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "afterClose", "onCancel", "onOk"]))
}